import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFSecureComponent } from './simple-icons-f-secure.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFSecureComponent ],
    exports:      [ SimpleIconsFSecureComponent ],
    bootstrap:    []
})
export class SimpleIconsFSecureModule {}
